import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { digitalFeatures } from '../../../mocks/asesoriaImagen';

export default function DigitalSystemSection() {
  const { ref, style } = useScrollReveal({
    threshold: 0.1,
    distance: 32,
    duration: 800,
  });
  const { ref: refGrid, style: styleGrid } = useScrollReveal({
    threshold: 0.1,
    distance: 28,
    duration: 800,
    delay: 200,
  });

  return (
    <section className="w-full bg-brand-black py-20 md:py-28 px-6 lg:px-[7%]">
      <div ref={ref} style={style} className="max-w-3xl">
        <span className="font-sans text-brand-sage text-[11px] tracking-[0.2em] uppercase font-medium">
          Tecnología al servicio del estilo
        </span>
        <h2 className="font-serif text-white text-[clamp(1.8rem,4vw,2.8rem)] leading-[1.3] mt-4">
          Tu armario, organizado en un sistema inteligente
        </h2>
        <p className="font-sans text-white/60 text-base leading-relaxed mt-6 max-w-2xl">
          El valor diferencial de nuestro servicio es el sistema digital que
          acompaña cada plan. No necesitas entender de tecnología: la plataforma
          trabaja para ti, mientras tú te concentras en lo importante.
        </p>
      </div>
      <div
        ref={refGrid}
        style={styleGrid}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12"
      >
        {digitalFeatures.map((f) => (
          <div
            key={f.id}
            className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 hover:bg-white/10 transition-colors duration-300"
          >
            <div className="w-10 h-10 flex items-center justify-center text-brand-sage mb-5">
              <i className={`${f.icon} text-2xl`} />
            </div>
            <h3 className="font-serif text-white text-lg font-medium">
              {f.title}
            </h3>
            <p className="font-sans text-white/50 text-sm leading-relaxed mt-3">
              {f.description}
            </p>
          </div>
        ))}
      </div>
      <div className="mt-12 flex justify-center">
        <div className="w-full max-w-3xl aspect-[16/7] rounded-2xl overflow-hidden bg-brand-gray-800">
          <img
            src="https://readdy.ai/api/search-image?query=digital-wardrobe-management-interface-elegant-minimal-UI-design-fashion-clothing-silhouettes-warm-neutral-tones-soft-lighting-luxury-tech-aesthetic-clean-modern-editorial&width=1000&height=700&seq=202&orientation=landscape"
            alt="Sistema digital de armario inteligente"
            className="w-full h-full object-cover object-top opacity-80"
          />
        </div>
      </div>
    </section>
  );
}